<template>
  <page-header titolo="Bacheca" icona="fa-house" sfondo="bkg-dashboard"></page-header>

  <div class="pol-container">
    <div class="card" >
      
      
      <div class="card-body">
        <h3>Scadenze</h3>
        <div class="d-flex justify-content-start mb-2">
          <div class="px-1"><button type="button" class="btn btn-sm btn-outline-primary" @click="Precedente">Prec.</button></div>
          <div class="px-1">
            <select class="form-control form-control-sm" v-model="meseSelezionato">
              <option value="1">gennaio</option>
              <option value="2">febbraio</option>
              <option value="3">marzo</option>
              <option value="4">aprile</option>
              <option value="5">maggio</option>
              <option value="6">giugno</option>
              <option value="7">luglio</option>
              <option value="8">agosto</option>
              <option value="9">settembre</option>
              <option value="10">ottobre</option>
              <option value="11">novembre</option>
              <option value="12">dicembre</option>
            </select>
          </div>
          <div class="px-1">
            <select class="form-control form-control-sm" v-model="annoSelezionato" @change="CambiaAnno">
              <option v-for="a, i in AnniPrecedenti" :key="i" :value="a">{{a}}</option>
              <option :value="annoSelezionato" selected>{{annoSelezionato}}</option>
              <option v-for="a, i in AnniSuccessivi" :key="i" :value="a">{{a}}</option>
            </select>
          </div>
          <div class="px-1">
            <button type="button" class="btn btn-sm btn-outline-primary" @click="AzzeraData">
              <font-awesome-icon :icon="'fa-solid fa-calendar-check'"></font-awesome-icon>
            </button>
          </div>
          <div class="px-1"><button type="button" class="btn btn-sm btn-outline-primary" @click="Successivo">Succ.</button></div>
          <div class="px-1">
            <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#modNuovaScad">
              <font-awesome-icon :icon="'fa-solid fa-plus'"></font-awesome-icon>&nbsp;Nuova scadenza
            </button>
          </div>
          <div class="px-1">
            <button type="button" class="btn btn-sm btn-outline-success" data-bs-toggle="modal" data-bs-target="#modExport">
              <font-awesome-icon :icon="'fa-solid fa-file-excel'"></font-awesome-icon>&nbsp;Esporta su Excel
            </button>
          </div>
        </div>
        <table class="tbScadenzario">
          <thead>
          <tr>
            <th v-for="d, i in GiorniMeseSelezionato" :key="i">{{ d }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="d, i in GiorniMeseSelezionato" :key="i" @dblclick="NuovaScad($event, d)">
              <div v-for="(sc, n) in ScadenzeDelGiorno(d)" :key="n">
                <div class="card text-dark bg-light cardScad" style="max-width: 10rem;" :class="{'cardElaborata' : sc.sca_stato == 1, 'cardScadutaNonElab': IsExpired(sc)}">
                  <div class="card-header" :style="'background-color:' + sc.dtp_colore">
                    {{ sc.dtp_titolo }}
                  </div>
                  <div class="card-body">
                    <!-- <h5 class="card-title">Light card title</h5>  -->
                    <p class="card-text" v-html="sc.sca_testo"></p>

                    <p class="card-text" style="font-weight: bold;" v-html="sc.doc_note_avanzamento" v-if="sc.doc_note_avanzamento != ''"></p>

                    <div v-if="sc.sca_stato == 1 && sc.sca_dtaElab != null" class="mb-2">
                      <small class="mb-3">chiusa il {{ snF.dateFormat(sc.sca_dtaElab, "dd-MM-yyyy")  }}</small>
                    </div>
                    
                    <!-- se è una scadenza generica permette di fare altro-->
                    <template v-if="sc.sca_tipo == 2">
                      <!-- SCADENZA GENERICA -->
                      <a href="#j" class="text-primary linkScad" @click="EditScad(sc)" data-bs-toggle="modal" data-bs-target="#modNuovaScad"><font-awesome-icon :icon="'fa-solid fa-edit'"></font-awesome-icon></a>
                    </template>
                    <template v-else>
                      <!-- SCADENZA DOCUMENTO -->
                      <router-link :to="'/documenti/' + sc.sca_idOggetto + '/' + sc.doc_idTipo" class="linkScad">
                        <font-awesome-icon :icon="'fa-solid fa-arrow-up-right-from-square'"></font-awesome-icon>
                      </router-link>
                    </template>
                    <!-- COMUNE -->
                    &nbsp;<a href="#j" class="text-danger linkScad" @click="DelScadenza(sc)"><font-awesome-icon :icon="'fa-solid fa-trash'"></font-awesome-icon></a>
                    <template v-if="sc.sca_stato == 0">
                      <!-- marca come elaborata -->
                      &nbsp;<a href="#j" class="text-success linkScad" @click="CambiaStato(sc)"><font-awesome-icon :icon="'fa-solid fa-check'"></font-awesome-icon></a>
                    </template>
                    <template v-else>
                      <!-- marca come NON elaborata -->
                      &nbsp;<a href="#j" class="text-warning linkScad" @click="CambiaStato(sc)"><font-awesome-icon :icon="'fa-solid fa-stop'"></font-awesome-icon></a>
                    </template>
                    
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        </table>
      </div>
    </div>

  </div>

  <!-- ******** -->
  <!-- **** DIALOG SCADENZA **** -->
  <!-- ******** -->
  <dialog-box idModal="modNuovaScad" titoloModal="Nuova scadenza 'Generica'" dimensioneModal="modal-lg" >
    <form>
            <div class="mb-3">
                <label for="sca_data" class="form-label">Data</label>
                <input type="date" class="form-control" v-model="oScadenza.sca_data">
            </div>
            <!-- <div class="mb-3">
                <label for="sca_tipo" class="form-label">Tipo</label>
                <input type="text" class="form-control" v-model="oScadenza.sca_tipo" >
            </div> -->
            <div class="mb-3">
                <label for="sca_testo" class="form-label">Testo</label>
                <textarea class="form-control" v-model="oScadenza.sca_testo" ></textarea>
            </div>
            
            <div class="mb-3">
                <label for="sca_stato" class="form-label">Stato</label>
                <select class="form-control" v-model="oScadenza.sca_stato" >
                  <option value="0">Attiva</option>
                  <option value="1">Elaborata</option>
                </select>
            </div>
                       

        </form>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
          <button type="button" class="btn btn-primary" @click="SalvaScadenza" >Salva</button>
        </template>
  </dialog-box>

  <!-- ******** -->
  <!-- **** DIALOG EXPORT **** -->
  <!-- ******** -->
  <dialog-box idModal="modExport" titoloModal="Export su Excel" dimensioneModal="modal-lg" >
    <form>
      <div class="mb-3">
          <label class="form-label">Data da</label>
          <input type="date" class="form-control" v-model="oExport.dataDa">
      </div>
      <div class="mb-3">
          <label class="form-label">Data a</label>
          <input type="date" class="form-control" v-model="oExport.dataA">
      </div>
    </form>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="ScaricaXML">Scarica</button>
    </template>
  </dialog-box>

  <iframe id="iFrameDn" src="about:blank" style="display:none"></iframe> 

</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import DialogBox from '@/components/DialogBox.vue';
import snFunctions from '@/lib/snFunctions.js';

export default {
  components: { PageHeader, DialogBox },
  inject: ['cfg'],
  data: function() {
    return {
      dtScadenze: [],

      meseSelezionato: new Date().getMonth() + 1,
      annoSelezionato: new Date().getFullYear(),

      oScadenza: {
        sca_id: -1,
        sca_data: null,
        sca_tipo: 2,
        sca_idOggetto: -1,
        sca_testo: "",
        sca_id_padre_ricorrenza: 0,
        sca_stato: 0,
        sca_idOpeElab: -1,
        sca_dtaElab: null,

        token: "",
      },

      oExport: {
        dataDa: null,
        dataA: null
      },

      snF: snFunctions

    }    
  },
  methods: {
    //Controlli selettore data
    AzzeraData() {
      this.meseSelezionato = new Date().getMonth() + 1;
      this.annoSelezionato = new Date().getFullYear();
      this.CaricaScadenze();
    },
    Precedente() {
      if(this.meseSelezionato > 1) this.meseSelezionato--;
      else if(this.meseSelezionato == 1) {
        this.meseSelezionato = 12;
        this.annoSelezionato--;
      }
      this.CaricaScadenze();
    },
    Successivo() {
      if(this.meseSelezionato < 12) this.meseSelezionato++;
      else if(this.meseSelezionato == 12) {
        this.meseSelezionato = 1;
        this.annoSelezionato++;
      }
      this.CaricaScadenze();
    },
    CambiaAnno() {
      this.CaricaScadenze();
    },

    //Recupero e gestione scadenze
    CaricaScadenze() {
      //Carica lista elementi
      this.$store.commit('Messaggio', {parms: [true, ['Recupero dati in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
      fetch(this.cfg.apisrv + "/api/Scadenze/GetListScadenze?token=" + this.$store.state.UserInfo.token + "&mese=" + this.meseSelezionato + "&anno=" + this.annoSelezionato)
      .then(response => response.json())
      .then(obj => {

          this.dtScadenze = obj;

          this.$store.commit('Messaggio', {parms: [true, ['Dati caricati.'], 'alert alert-success', 'fa-check', false, 2000]});
        
      });
    },

    //Filtra scadenze
    ScadenzeDelGiorno(gg) {
      //console.log("Entrato" + gg)
      let res = [];
      for(let i = 0; i < this.dtScadenze.length; i++) {
        //console.log(" Data : " + this.dtScadenze[i].sca_data.substring(8,10))
        if(this.dtScadenze[i].sca_data.substring(8,10) == gg) {
          //console.log("** Push : " + gg)
          res.push(this.dtScadenze[i]);
        }
      }
      return res;
    },


    EditScad(sc) {

      this.oScadenza.sca_id = sc.sca_id;
      this.oScadenza.sca_data = snFunctions.dateFormat(sc.sca_data, "yyyy-MM-dd");
      this.oScadenza.sca_tipo = sc.sca_tipo;
      this.oScadenza.sca_testo = sc.sca_testo;
      this.oScadenza.sca_stato = sc.sca_stato;

    },

    NuovaScad(e, day) {
      //alert(e.target.tagName + " " + day )
      if(e.target.tagName == "TD") {
        //lo fa solo sul TD
        let dta = new Date(this.annoSelezionato, this.meseSelezionato, day);
        this.oScadenza.sca_data = snFunctions.dateFormat(dta, "yyyy-MM-dd");

         
        var myModalEl = document.getElementById('modNuovaScad')
        var modal = bootstrap.Modal.getInstance(myModalEl) // eslint-disable-line 
        if(modal == null) {
          var myModal = new bootstrap.Modal(document.getElementById('modNuovaScad')) // eslint-disable-line
          myModal.show();



        } else modal.show();
        
        



      }
    },

    //Salva la scadenza generica
    SalvaScadenza() {
        let oSubmit = [];
        oSubmit = this.oScadenza;
        oSubmit.token = this.$store.state.UserInfo.token;

        fetch(this.cfg.apisrv + "/api/Scadenze/SalvaScadenza", {
            "method": "POST",
            "headers": {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "body": JSON.stringify(oSubmit)
        }).then(response => response.json())
            .then(obj => {
                if (obj.status == "OK") {
                   
                  var myModalEl = document.getElementById('modNuovaScad')
                  var modal = bootstrap.Modal.getInstance(myModalEl) // eslint-disable-line 

                  modal.hide();

                  this.CaricaScadenze();
               
                }
                else {
                  this.$store.commit('Messaggio', {parms: [true, obj.dati, 'alert alert-danger', 'fa-times', false, 3000]});
               
                }
            });

      },
      DelScadenza(sc) {
        //Cancella elemento singolo
        if(confirm("Cancellare l'elemento?")) {
            fetch(this.cfg.apisrv + "/api/Scadenze/DelScadenza?token=" + this.$store.state.UserInfo.token + "&idSca=" + sc.sca_id)
            .then(response => response.json())
            .then(obj => {
                this.CaricaScadenze();
            });
        }

      },

      CambiaStato(sc) {
        if(confirm("Cambiare lo stato dell'elemento?")) {
          let stato = 0;
          if(sc.sca_stato == 0) stato = 1;
          if(sc.sca_stato == 1) stato = 0;
            fetch(this.cfg.apisrv + "/api/Scadenze/CambiaStato?token=" + this.$store.state.UserInfo.token + "&idSca=" + sc.sca_id + "&setStato=" + stato)
            .then(response => response.json())
            .then(obj => {
                this.CaricaScadenze();
            });
        }

      },

      //Controlla se la scadenza è spirata o meno
      IsExpired(sc) {
        let stato = false;
        let oggi = new Date();
        let dtaScad = new Date(sc.sca_data.substring(0, 4), parseInt(sc.sca_data.substring(5, 7), 10) - 1, sc.sca_data.substring(8, 10));
        //console.log(sc.sca_stato + " " + dtaScad)
        if(sc.sca_stato == 0 && dtaScad < oggi) {
          stato = true;
        }

        return stato;
      },

      //Scarica XML delle scadenze
      ScaricaXML() {
        let url =this.cfg.apisrv + "/api/Scadenze/ScaricaXML?token=" + this.$store.state.UserInfo.token + "&dtaDa=" + this.oExport.dataDa + "&dtaA=" + this.oExport.dataA ;
        let iFrameDn = document.getElementById("iFrameDn");
        iFrameDn.src = url;
        //iFrameDn.reload();
        
      },


  },
  computed: {
    // AnnoCorrente() {
    //   return new Date().getFullYear();
    // },
    AnniPrecedenti() {
      let anno = this.annoSelezionato;
      let annip = [];
      for(let ap = anno -5; ap < anno; ap++) {
        annip.push(ap);
      }
      return annip;
    },
    AnniSuccessivi() {
      let anno = this.annoSelezionato;
      let annis = [];
      for(let as = 1; as <= 5; as++) {
        annis.push(anno + as);
      }
      return annis;
    },
    MeseCorrente() {
      return new Date().getMonth() + 1;
    },
    GiorniMeseSelezionato() {
      return new Date(this.annoSelezionato, this.meseSelezionato, 0).getDate();
    },

    

  },
  mounted: function() {
    if(this.$store.state.UserInfo.token == '') this.$router.push("/");

    this.CaricaScadenze();
  }
}
</script>

<style scoped>

table.tbScadenzario {
  width:100%;
}

table.tbScadenzario th {
  background-color: #000;
  color:#fff;
  padding:3px;
  text-align:center;
  border:solid 1px #fff;
}
table.tbScadenzario td {
  height: 250px;
  overflow: auto;
  background-color:#faf5c7;
  
  padding-top:10px;
  padding-bottom:10px;
  
}

/* card dele scadenze */
div.cardScad {
  margin-bottom: 5px;
}

/* card scadute ma non ancora elaborate */
div.cardScadutaNonElab {
  /* border:solid 2px red;*/
  -webkit-box-shadow: 5px 5px 18px 0px #FF6600;
  -moz-box-shadow: 5px 5px 18px 0px #FF6600;
  -o-box-shadow: 5px 5px 18px 0px #FF6600;
  box-shadow: 5px 5px 18px 0px #FF6600;
}

div.cardElaborata {
  opacity: 0.5;
}

div.cardScad > div.card-header {
  color:#fff;
  padding:4px;
  font-size: 12px;
}

div.cardScad > div.card-body {
  padding:6px;
  font-size: 11px;
}

.linkScad {
  font-size: 1.3em;
}

</style>